import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A7A7B1",
      "fill-rule": "evenodd",
      d: "M11.738 6.485h2.88c.096.096.103.583.103.72v7.457c0 .85-.692 1.543-1.543 1.543H4.821c-.85 0-1.543-.693-1.543-1.543V3.348c0-.851.693-1.543 1.543-1.543H9.19c.164 0 .657-.001.75.09v2.79a1.8 1.8 0 0 0 1.8 1.8m-2.731.677-.095.005a.75.75 0 0 0 0 1.49L9 8.661l.095-.006a.75.75 0 0 0 0-1.49zM9 9.412h-.75l-.088.005a.75.75 0 0 0 0 1.49l.088.005v2.25l.005.087a.75.75 0 0 0 .657.657l.088.006h.75l.087-.006a.75.75 0 0 0 .657-.657l.005-.087-.005-.088a.75.75 0 0 0-.573-.643l-.084-.015-.087-.004v-2.25l-.006-.088a.75.75 0 0 0-.657-.657z",
      "clip-rule": "evenodd",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#6E6E7D",
      d: "M11.02 4.954v-2.79l3.24 3.24h-2.79a.45.45 0 0 1-.45-.45",
      style: {"fill":"color(display-p3 .4296 .4296 .4915)","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }